class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this._boundSubmitHandler = this.handleSubmit.bind(this); 
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.webhook = this.dataset.webhook;
    this.responseBox = this.querySelector(".newsletter-response");
    this.successText = this.dataset.successText || "נרשמת בהצלחה!";
    this.errorText = this.dataset.errorText || "אירעה שגיאה, נסה שוב מאוחר יותר.";

    if (!this.form) return;

    this.form.addEventListener("submit", this._boundSubmitHandler);
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("submit", this._boundSubmitHandler);
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const emailInput = this.form.querySelector("[name='email']");
    const button = this.form.querySelector("button[type='submit']");
    const response = this.responseBox;
    if (!emailInput || !this.webhook) return;

    const email = emailInput.value.trim();
    if (!email) return this.showResponse("נא להזין כתובת אימייל תקינה", "danger");

    button.disabled = true;
    const originalText = button.textContent.trim();
    button.innerHTML = `<span class="spinner-border spinner-border-sm"></span>`;
    response.classList.add("d-none");

    try {
      const res = await fetch(this.webhook, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("Webhook returned error");

      this.showResponse(this.successText, "success");
      this.form.reset();
    } catch (err) {
      console.error("[NewsletterForm] Error:", err);
      this.showResponse(this.errorText, "danger");
    } finally {
      button.disabled = false;
      button.innerHTML = `
        ${originalText}
        <svg class="icon" viewBox="0 0 100 100">
          <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
        </svg>
      `;
    }
  }

  showResponse(message, type = "info") {
    const response = this.responseBox;
    response.textContent = message;
    response.className = `newsletter-response mt-2 small text-center text-${type}`;
    response.classList.remove("d-none");
  }
}

customElements.define("newsletter-form", NewsletterForm);
